export default from './UsersPage';



// WEBPACK FOOTER //
// ./src/pages/users/index.js